import React, { useContext } from 'react';
import { getPentaDesign } from '../utilsPenta';

import { LangContext } from '../../contexts/langContext';
import { AstroIcon } from '../UiKit/AstroIcon';
import { TooltipH } from '../UiKit/TooltipH';


export const PentaStats = ({
  markers,
  handleMarkers = () => { },
  penta = {},
  size = 20
}) => {
  const context = { ...useContext(LangContext) };
  const $ui = context.$ui;

  const pentaDesign = penta.pentaDesign || (penta.members?.length >= 2 ? getPentaDesign(penta) : null);
  // console.log('pentaDesign123 = ', pentaDesign);

  return (<>
    {pentaDesign && <div className="x_penta_stats">

      <TooltipH mobileOff title={$ui('penta_composite9')} placement='bottom'>
        <div className="x_penta_stat1">
          <div className="x_penta_stat_ico">
            <AstroIcon name="penta-comp" size={size} />
          </div>
          <div className="x_penta_stat_num">
            {pentaDesign['nine']}
          </div>
        </div>
      </TooltipH>

      <TooltipH mobileOff title={$ui('penta_em_channels')} placement='bottom'>
        <div className={`x_penta_stat1 ${Boolean(pentaDesign['em']?.length) ? '' : 'x_penta_stat1--0'} ${markers === 'em' ? 'active' : ''}`}
          onClick={() => handleMarkers('em')}
        >
          <div className="x_penta_stat_ico">
            <AstroIcon name="penta-em" size={size} />
          </div>
          <div className="x_penta_stat_num">
            {pentaDesign['em']?.length}
          </div>
        </div>
      </TooltipH>

      <TooltipH mobileOff title={$ui('penta_same_channels')} placement='bottom'>
        <div className={`x_penta_stat1 ${Boolean(pentaDesign['same']?.length) ? '' : 'x_penta_stat1--0'} ${markers === 'same' ? 'active' : ''}`}
          onClick={() => handleMarkers('same')}
        >
          <div className="x_penta_stat_ico">
            <AstroIcon name="penta-same" size={size} />
          </div>
          <div className="x_penta_stat_num">
            {pentaDesign['same']?.length}
          </div>
        </div>
      </TooltipH>

      <TooltipH title={$ui('penta_same_gates')} placement='bottom'>
        <div className={`x_penta_stat1 ${Boolean(pentaDesign['sameGates']?.length) ? '' : 'x_penta_stat1--0'} ${markers === 'sameGates' ? 'active' : ''}`}
          onClick={() => handleMarkers('sameGates')}
        >
          <div className="x_penta_stat_ico">
            <AstroIcon name="penta-same-gates" size={size} />
          </div>
          <div className="x_penta_stat_num">
            {pentaDesign['sameGates']?.length}
          </div>
        </div>
      </TooltipH>

      <TooltipH mobileOff title={$ui('penta_dom_channels')} placement='bottom'>
        <div className={`x_penta_stat1 ${Boolean(pentaDesign['dom']?.length) ? '' : 'x_penta_stat1--0'} ${markers === 'dom' ? 'active' : ''}`}
          onClick={() => handleMarkers('dom')}
        >
          <div className="x_penta_stat_ico">
            <AstroIcon name="penta-dom" size={size} />
          </div>
          <div className="x_penta_stat_num">
            {pentaDesign['dom']?.length}
          </div>
        </div>
      </TooltipH>


    </div>}
  </>
  );
};


